import * as React from "react";
import { css, cx } from "emotion";
import { getThemeColorVar } from "../helper/color";
const defaultProps = {};
const panelClass = css({
    "&:before, &:after": {
        content: '" "',
        display: "table",
    },
    "&:after": {
        clear: "both",
    },
    padding: "10px 15px",
    borderRadius: "3px",
    backgroundColor: getThemeColorVar("white", undefined),
    border: `1px solid ${getThemeColorVar("border", "default")}`,
});
const titleClass = css({
    fontWeight: 600,
    display: "block",
    margin: "0 0 5px 0",
});
export const Panel = (props) => {
    const classes = [panelClass];
    const titleClasses = [titleClass];
    if (props.color) {
        classes.push(css({
            color: getThemeColorVar(props.color, "dark"),
            backgroundColor: getThemeColorVar(props.color, "light"),
            borderColor: getThemeColorVar(props.color, "default"),
        }));
        titleClasses.push(css({
            color: getThemeColorVar(props.color, "dark"),
        }));
    }
    return (React.createElement("div", { id: props.id, className: cx(classes) },
        props.title && React.createElement("div", { className: cx(titleClasses) }, props.title),
        props.children));
};
Panel.defaultProps = defaultProps;
export default Panel;
//# sourceMappingURL=panel.js.map